export default __webpack_public_path__ + "static/media/notification-button-arrow-blue.874ca1ed.svg";